import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _extends from 'babel-runtime/helpers/extends';
import _typeof from 'babel-runtime/helpers/typeof';
import _Promise from 'babel-runtime/core-js/promise';
import 'fetch-utilities';

/*
  view.js
  ------------------------------------------------------------

  Load data by URL and assign the proper type to the
  application state depending on what we get back
*/


var HINT = "store/view/HINT";

var VIEW_LOADED = "store/view/LOADED";

/**
 * Hints of an upcoming navigation-event with data.
 *
 * The `url` is expected to be the last segment of the URL being hinted (excluding leading).
 */
var hint = function hint(type, url, data) {
  return {
    type: HINT,
    hintUrl: url,
    hintType: type,
    hintData: data
  };
};

var PRODUCT_TYPE = "product";

var PENDING = "store/product/PENDING";
var LOADED = "store/product/LOADED";
var SET_QTY = "store/product/SET_QTY";
var SET_OPTION = "store/product/SET_OPTION";
var SET_IMAGE = "store/product/SET_IMAGE";
var SET_CUSTOM_OPTION = "store/product/SET_CUSTOM_OPTION";
var SET_SELECTION = "store/product/SET_SELECTION";
var SET_FORM_DATA = "store/product/SET_FORM_DATA";

var initialState = {
  state: PENDING,
  product: null,
  activeImage: null,
  form: {
    attributes: {},
    bundleOptions: {},
    customOptions: {},
    qty: 1
  }
};

function reducer$$1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case VIEW_LOADED:
      if (action.error || _typeof(action.payload) !== "object" || action.payload.type !== PRODUCT_TYPE) {
        // Reset when we load another view
        return _extends({}, initialState);
      }

      return _extends({}, initialState, {
        state: LOADED,
        product: action.payload.product,
        form: action.payload.product.selections ? _extends({}, state.form, {
          bundleOptions: action.payload.product.selections.reduce(function (a, s) {
            var defaultOption = s.options ? s.options.find(function (o) {
              return o.isDefault;
            }) : null;
            return defaultOption ? _extends({}, a, _defineProperty({}, s.id, defaultOption.id)) : a;
          }, state.form.bundleOptions)
        }) : state.form
      });

    case HINT:
      if (action.hintType !== PRODUCT_TYPE) {
        return state;
      }

      // TODO: Maybe flag that it is incomplete?
      return _extends({}, initialState, {
        state: LOADED,
        product: action.hintData
      });

    case SET_CUSTOM_OPTION:
      return _extends({}, state, {
        form: _extends({}, state.form, {
          customOptions: _extends({}, state.form.customOptions, _defineProperty({}, action.key, action.value))
        })
      });

    case SET_SELECTION:
      return _extends({}, state, {
        form: _extends({}, state.form, {
          bundleOptions: _extends({}, state.form.bundleOptions, _defineProperty({}, action.key, action.value))
        })
      });

    case SET_QTY:
      return _extends({}, state, {
        form: _extends({}, state.form, {
          qty: action.qty
        })
      });

    case SET_OPTION:
      {
        return _extends({}, state, {
          activeImage: action.selectedValue.largeImage || state.activeImage,
          maxQty: action.selectedValue.stockQty,
          form: _extends({}, state.form, {
            qty: action.selectedValue.stockQty && action.selectedValue.stockQty < state.form.qty ? action.selectedValue.stockQty : state.form.qty,
            attributes: _defineProperty({}, action.optionId, action.selectedValue.id)
          })
        });
      }

    case SET_IMAGE:
      {
        return _extends({}, state, {
          activeImage: action.src
        });
      }

    case SET_FORM_DATA:
      return _extends({}, state, {
        form: _extends({}, state.form.data, action.data)
      });

    default:
      return state;
  }
}

var hintProduct = function hintProduct(product) {
  return hint(PRODUCT_TYPE, product.urlKey, product);
};

var setQty = function setQty(qty) {
  return {
    type: SET_QTY,
    qty: qty
  };
};

var setOption = function setOption(optionId, selectedValue) {
  return {
    type: SET_OPTION,
    optionId: optionId,
    selectedValue: selectedValue
  };
};

var setActiveImage = function setActiveImage(src) {
  return {
    type: SET_IMAGE,
    src: src
  };
};

var setCustomOption = function setCustomOption(key, value) {
  return {
    type: SET_CUSTOM_OPTION,
    key: key,
    value: value
  };
};

var setSelection = function setSelection(key, value) {
  return {
    type: SET_SELECTION,
    key: key,
    value: value
  };
};

var setFormData = function setFormData(data) {
  return { type: SET_FORM_DATA, data: data };
};

export { PENDING, LOADED, SET_QTY, SET_OPTION, SET_IMAGE, SET_CUSTOM_OPTION, SET_SELECTION, SET_FORM_DATA, hintProduct, setQty, setOption, setActiveImage, setCustomOption, setSelection, setFormData };
export default reducer$$1;
